import React from 'react';
import { formatNumber } from '../../utils';

export default function Number({ children, enableToFixed, removeDecimalSpace = true }) {
	return <span className="value">{formatNumber(children, enableToFixed, removeDecimalSpace)}</span>;
}